/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {


  /////////////////////////////////
  ////// FUNCTIONS
  ////////////////////////////////
  //
  // Site is modular, meaning we should have access to all functions across the site.
  // Most functions calls will be made in 'common' unless specific to a page
  // This allows the code to run on all but template specific pages, i.e cart.


  // Updates the string above the homepage search.
  function update_home_text_string(){
    var text = $('.search_home_text').val();

    window.setTimeout(function(){
      if(text != '' && text != null && text != ' '){
        $('.home_search_ellipse').text(text);
      }else{
        $('.home_search_ellipse').text('...');
      }
    }, 500);
  }

  //Sets the height of the blocks on the homepage - only fired if screen is larger than mobile phone
  function set_size_homepage_block(){
    if($(window).width() > 900){
      $('.home-page-block').css('height', $('.home-page-block').width());
    }else{
      $('.home-page-block').css('height', 'auto');
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

          $('.ed-search-icon').click(function(){
              $('.ed-header-search-form-wrapper').show();
          });

          $('.ed-form-close').click(function(){
              $('.ed-header-search-form-wrapper').hide();
          });

          function replaceQueryParam(param, newval, search) {
              var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
              var query = search.replace(regex, "$1").replace(/&$/, '');
              return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
          }

          var $_GET=[];
          window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(a,name,value){$_GET[name]=value;});

          $(document).on('change', '#course-search-category-select', function(){
              var categorySlug = $(this).find(':selected').val();
              window.location = '/our-courses/' + replaceQueryParam('course-category', categorySlug, window.location.search)
          });

          $(document).on('change', '#course-search-sub-category-select', function(){
              var categorySlug = $(this).find(':selected').val();
              window.location = '/our-courses/' + replaceQueryParam('course-category', categorySlug, window.location.search)
          });

          if($_GET["course-category"]){
              var mainCategorySelect = $('#course-search-category-select');
              var subCategorySelect = $('#course-search-sub-category-select');
              var parentCategoryID = subCategorySelect.find(':selected').data('parentid');

              subCategorySelect.removeClass('course-search-sub-category-select-disabled');
              subCategorySelect.prop("disabled", false);
              mainCategorySelect.find("option[data-categoryid=" + parentCategoryID + "]").attr("selected", "selected");

              var categoryID = mainCategorySelect.find(':selected').data('categoryid');

              $('.sub-category').hide();
              $('.sub-category-of-' + categoryID).show();
          }

          var advancedFiltersLink = $('.advanced-filters-link');
          var advancedFiltersWrapper = $('.course-search-advanced-filters');
          advancedFiltersLink.click(function(){

              if(advancedFiltersWrapper.is(':visible')){
                  advancedFiltersWrapper.slideUp();
                  advancedFiltersLink.removeClass('advanced-filters-link-open');
              } else {
                  advancedFiltersWrapper.slideDown();
                  advancedFiltersLink.addClass('advanced-filters-link-open');
              }
              return false;
          });

          var stickyNav = $('.ed-sticky-nav');
          var headerBanner = $('.banner');
          stickyNav.find('.search-icon-fixed-nav').click(function(){
              stickyNav.find('.search-form').addClass('search-form-open');
              stickyNav.find('.search-form').show();
          });

          stickyNav.find('.form-close').click(function(){
              stickyNav.find('.search-form').removeClass('search-form-open');
          });

          $(document).on('scroll', function() {
              if($(this).scrollTop() >= 500){
                  stickyNav.addClass('ed-nav-stuck');
              } else {
                  stickyNav.removeClass('ed-nav-stuck');
              }
          });
      },
      finalize: function() {

          $(document).ready(function(){
              $('.wpcf7').on('wpcf7mailsent', function(){
                  $(this).parent().find('p').slideUp();
              });

              var gFormConfirmationWrapper = $('.gform_confirmation_wrapper');
              if(gFormConfirmationWrapper.is(':visible')){
                  gFormConfirmationWrapper.parent().find('p').not('.quick-enquiry-thank-you').hide();
              }
          });

        //Logo Owl Carousel Code
        var carousel_footer = $(".owl-carousel").owlCarousel({
          items:8,
          slideBy: 6,
          loop:true,
          margin:10,
          autoplay:0,/**/
          responsive:{
            0: {
              items: 1
            },
            330: {
              items: 2
            },
            500: {
              items: 3
            },
            800: {
              items: 4
            },
            1000: {
              items: 6
            }
          }
        });

        $('.carousel-button.next').click(function() {
            carousel_footer.trigger('next.owl.carousel');
        });
        $('.carousel-button.prev').click(function() {
            carousel_footer.trigger('prev.owl.carousel');
        });


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {

        //Resize homepage blocks
        set_size_homepage_block();

        //On select change, update the text value
        $('#search_home_select').change(function(){
          var theType = $('#search_home_select').val();
            $('.home_search_value').fadeOut(100, function(){

              if(theType == 'course'){
                  $('.home_search_value').text('a course in');
              }

              if(theType == 'diploma'){
                  $('.home_search_value').text('a diploma in');
              }

              if(theType == 'award'){
                  $('.home_search_value').text('an award in');
              }

              if(theType == 'seminar'){
                  $('.home_search_value').text('a seminar in');
              }

            $('.home_search_value').fadeIn(100);

          });
        });

        // $('.search_home_text').keypress(function(){
        //   update_home_text_string();
        // });
        // $('.search_home_text').change(function(){
        //   update_home_text_string();
        // });







      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

    function checkImLookingFor(){

        var placeholder = jQuery('.home_search_value');
        var select = jQuery('#search_home_select');

        var count = 0;
        var wordsArray = ["a course in", "a diploma in", "a seminar in", "an award in"];

        var interval = setInterval(function () {
            if(select.val() !== ''){
                clearInterval(interval);
            }else {
                count++;
                placeholder.fadeOut(1000, function () {
                    jQuery(this).text(wordsArray[count % wordsArray.length]).fadeIn(1000);
                });
            }

        }, 2000);

    }

    jQuery('#search_home_select').change(function(){
        checkImLookingFor();
    }).change();

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  //order table jh
	$( window ).load(function() {
		if($('#course-table').length) 
		  {
		    $('#course-table').DataTable({
			    order: [],
	            columnDefs: [ { orderable: false, targets: [3] } ],
	            "iDisplayLength": 20,
	            "lengthMenu": [[20, 50, 75, -1], [20, 50, 75, "All"]]
			    });
		    }
	    });

  // Load Events
  $(document).ready(UTIL.loadEvents);

  jQuery('.select2').select2();
    

})(jQuery); // Fully reference jQuery after this point.
